import { hexToRgb } from '@website/common/utils'
export default {
  DARK: {
    border: () => 'none',
    shadow: () => 'none',
    buttonShadow: () => 'none',
    raisedShadow: () => 'none',
    heading: p => p.accentWhite,
    paragraph: p => p.accentWhite,
    background: p => `rgba(${hexToRgb(p.tertiaryDark)}, 1)`,
    overlay: p => `rgba(${hexToRgb(p.primaryDark)}, 0.4)`,
    overlayWithoutOpacity: p => `rgba(${hexToRgb(p.primaryDark)}, 1)`,
    overlayLight: p => `rgba(${hexToRgb(p.primaryLight)}, 0.4)`,
    overlayLightWithoutOpacity: p => `rgba(${hexToRgb(p.primaryLight)}, 1)`
  },
  LIGHT: {
    heading: p => p.tertiaryDark,
    paragraph: p => p.tertiaryNormal,
    background: p => `rgba(${hexToRgb(p.tertiaryLight)}, 1)`,
    overlay: p => `rgba(${hexToRgb(p.primaryDark)}, 0.4)`,
    overlayWithoutOpacity: p => `rgba(${hexToRgb(p.primaryDark)}, 1)`,
    overlayLight: p => `rgba(${hexToRgb(p.primaryLight)}, 0.4)`,
    overlayLightWithoutOpacity: p => `rgba(${hexToRgb(p.primaryLight)}, 1)`
  },
  EXTRALIGHT: {
    heading: p => p.tertiaryDark,
    paragraph: p => p.tertiaryNormal,
    background: p => `rgba(${hexToRgb(p.tertiaryExtraLight)}, 1)`,
    overlay: p => `rgba(${hexToRgb(p.primaryDark)}, 0.4)`,
    overlayWithoutOpacity: p => `rgba(${hexToRgb(p.primaryDark)}, 1)`,
    overlayLight: p => `rgba(${hexToRgb(p.primaryLight)}, 0.4)`,
    overlayLightWithoutOpacity: p => `rgba(${hexToRgb(p.primaryLight)}, 1)`
  }
}
